import type { FC, PropsWithChildren } from "react";

export const StepContent: FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="@container">
            <div className="flex flex-col items-start justify-between gap-4 overflow-hidden @md:flex-row @md:items-center">
                {children}
            </div>
        </div>
    );
};
